import { render } from "./UnloginedModal.vue?vue&type=template&id=22bde735&scoped=true"
import script from "./UnloginedModal.vue?vue&type=script&lang=js"
export * from "./UnloginedModal.vue?vue&type=script&lang=js"

import "./UnloginedModal.vue?vue&type=style&index=0&id=22bde735&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22bde735"]])

export default __exports__